"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const logger = {
    log: (...args) => console.log(...args),
    error: (...args) => console.error(...args),
    warn: (...args) => console.warn(...args),
    info: (...args) => console.info(...args),
    debug: (...args) => console.debug(...args),
    verbose: (...args) => console.log('verbose:', ...args),
    silly: (...args) => console.log('silly:', ...args),
};
exports.default = logger;
exports.log = logger.log.bind(logger);
exports.error = logger.error.bind(logger);
exports.warn = logger.warn.bind(logger);
exports.info = logger.info.bind(logger);
exports.debug = logger.debug.bind(logger);
exports.verbose = logger.verbose.bind(logger);
exports.silly = logger.silly.bind(logger);
//# sourceMappingURL=logger.browser.js.map